"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _search.default;
  }
});
var _search = _interopRequireDefault(require("./search"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }